import { Spacing, Text, Title } from '@vkontakte/vkui';
import img from 'img/tooltip/sharing-onboarding-autodelete-tooltip.png';
import React, { type RefObject, useCallback } from 'react';
import { useSelector } from 'react-redux';
import { emitAnalyticEvent } from 'reactApp/appHelpers/experimentAnalytic';
import { AnalyticEventNames } from 'reactApp/appHelpers/experimentAnalytic/eventNames';
import { UserSelectors } from 'reactApp/modules/user/user.selectors';
import { FloatingTooltip } from 'reactApp/ui/FloatingTooltip/FloatingTooltip';
import { ETooltipPlacement } from 'reactApp/ui/FloatingTooltip/FloatingTooltip.types';
import { sendPaymentGa } from 'reactApp/utils/paymentGa';

import styles from './AutoDeleteOnboardingTooltip.css';

interface AutoDeleteOnboardingTooltipProps {
    target: RefObject<HTMLElement> | Element | null;
    onClose: () => void;
}

export function AutoDeleteOnboardingTooltip({ target, onClose }: AutoDeleteOnboardingTooltipProps) {
    const isPaidUser = useSelector(UserSelectors.isPaidUser);

    const onTooltipShow = useCallback(() => {
        emitAnalyticEvent(AnalyticEventNames.ONBOARDING_TOOLTIP_SHOW, { source: 'autodelete' });
        sendPaymentGa({ eventCategory: 'autodelete-tooltip', action: 'show' });
    }, [isPaidUser]);

    const onTooltipClose = useCallback(() => {
        emitAnalyticEvent(AnalyticEventNames.ONBOARDING_TOOLTIP_CLOSE, { source: 'autodelete' });
        sendPaymentGa({ eventCategory: 'autodelete-tooltip', action: 'close' });
        onClose();
    }, [onClose, isPaidUser]);

    return (
        <FloatingTooltip
            contentClassName={styles.root}
            target={target}
            placement={ETooltipPlacement.right}
            qaId="autodelete-onboarding-tooltip"
            withinModal
            closable
            closeOnOutsideClick
            usePortal
            onShow={onTooltipShow}
            onClose={onTooltipClose}
        >
            <div className={styles.tooltip}>
                <Title className={styles.tooltipTitle}>Настраивайте автоудаление</Title>
                <Spacing size={4} />
                <Text className={styles.tooltipText}>Облако не&nbsp;придётся чистить&nbsp;&mdash; папка удалится сама по&nbsp;таймеру</Text>
                <img src={img} alt="Настраивайте автоудаление" className={styles.image} />
            </div>
        </FloatingTooltip>
    );
}
